import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AccArrowCont,
  AccHeaderScoreCont,
  AccHeaderTopic,
  AccordionTableHeaderCont,
  TileAccHeaderSide,
} from './CategoriesAndTopicsTileAccordionHeader.styles';
import { useNestedSort } from '../../../../hooks/useNestedSort';
import { CaptionBoldLUppercase } from '../../../../styles/globals';
import Arrow from '@/assets/icons/filledDownArrow.svg?react';

interface ICategoriesAndTopicsTileAccordionHeader {
  code: string;
  sortFilters: { key: string; value: string };
  isTotalsTabActive: boolean;
}

const CategoriesAndTopicsTileAccordionHeader: FC<ICategoriesAndTopicsTileAccordionHeader> = ({
  code,
  sortFilters,
  isTotalsTabActive,
}) => {
  const { t } = useTranslation();
  const { key, value } = sortFilters;
  const intialSort = {
    score: value,
  };
  const scoreStateActive = key === 'score' && value === 'asc';
  const scoreStateInActive = (key === 'score' && value === 'default') || value === null;

  const { manageTripleSortState } = useNestedSort(intialSort, code, 'surveyReport');
  return (
    <AccordionTableHeaderCont id="AccordionTableHeaderCont">
      <TileAccHeaderSide id="TileAccHeaderSide" onClick={() => manageTripleSortState('score')}>
        <AccHeaderTopic id="AccHeaderTopic">{t('report.results.topic')}</AccHeaderTopic>
        {isTotalsTabActive && (
          <AccHeaderScoreCont id="AccHeaderScoreCont">
            <AccArrowCont id="AccArrowCont" inActive={scoreStateInActive} active={scoreStateActive}>
              <CaptionBoldLUppercase id="CaptionBoldLUppercase">
                {t('report.results.score')}
              </CaptionBoldLUppercase>
              <Arrow />
            </AccArrowCont>
          </AccHeaderScoreCont>
        )}
      </TileAccHeaderSide>
    </AccordionTableHeaderCont>
  );
};
export default CategoriesAndTopicsTileAccordionHeader;
